import React from 'react';

import styles from './circular-progress.module.scss';

type CircularProgressProps = Omit<React.ComponentPropsWithoutRef<'div'>, 'style'> & {
  /** Completion from 0 to 100. Drives the conic-gradient sweep. */
  progress: number;
};

export const CircularProgress = ({ progress, className, ...props }: CircularProgressProps) => (
  <div
    className={
      className ? `${styles['circular-progress']} ${className}` : styles['circular-progress']
    }
    style={{ '--progress-angle': `${progress * 3.6}deg` } as React.CSSProperties}
    {...props}
  />
);
